
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class ManageGrowthModule extends Vue {
  formatUpyunUrl = formatUpyunUrl;

  pic1 = "/img/7e7b032f9dace6e6d21f2be95d95368a.png";
  pic2 = "/img/30987926222ada74737e3c936bfbc238.png";
  pic3 = "/img/0088fa5af1db0cf80addbec2ea46d6ef.png";
  pic4 = "/img/8cb7839d82240ae0cc71b6139dc50715.png";
}
